import classNames from 'classnames';
import React, {FC, SetStateAction} from 'react';
import disabledRemoveFileIcon from '~/shared/legacy_res/img/svg/trash-box-disabled.svg';
import removeFileIcon from '~/shared/legacy_res/img/svg/trash-box.svg';
import styles from './DisplayAttachments.module.scss';

export interface DisplayAttachmentsProps {
    fileList: File[];
    disableRemove: boolean;
    hideRemove: boolean;
    setFileList: (fileList: SetStateAction<File[]>) => void;
    customClassName?: string;
}

/**
 * @deprecated After releasing new KYC flow, use {@link FileList}
 */
const DisplayAttachments: FC<DisplayAttachmentsProps> = ({
    fileList,
    disableRemove,
    hideRemove,
    setFileList,
    customClassName,
}) => {
    const liClassName = classNames({[styles.center]: hideRemove});

    const convertSize = (bytes: number) => {
        const mb = bytes / Math.pow(1000, 2);
        return mb < 1 ? `${(bytes / 1000).toFixed(1)}KB` : `${mb.toFixed(1)}MB`;
    };

    const renderAttachmentsList = () => {
        const fileExtensionRegexp = /\.[0-9a-z]+$/i;
        const files = Array.from(fileList).map((file, index) => {
            const displayExtension = file.name.match(fileExtensionRegexp) ?? [''];
            return (
                <li key={index} className={liClassName}>
                    <div className={styles.extension}>{displayExtension[0].replace('.', '').toUpperCase()}</div>
                    <div className={styles.filename}>
                        <div className={styles.name}>{file.name}</div>
                        <div className={styles.size}>{convertSize(file.size)}</div>
                    </div>
                    {!hideRemove && (
                        <RemoveButton
                            disabled={disableRemove}
                            onRemove={() => {
                                setFileList(prevState => {
                                    const newFileList = [...prevState];
                                    newFileList.splice(index, 1);
                                    return newFileList;
                                });
                            }}
                        />
                    )}
                </li>
            );
        });
        return files;
    };

    return (
        <div className={classNames(styles.attachments, customClassName)}>
            Attachments
            <ul>{renderAttachmentsList()}</ul>
        </div>
    );
};

export default DisplayAttachments;

function RemoveButton({disabled, onRemove}: {disabled: boolean; onRemove: () => void}) {
    return (
        <button type='button' disabled={disabled} onClick={onRemove} className={styles.removeButton}>
            <img src={disabled ? disabledRemoveFileIcon : removeFileIcon} alt='remove' />
        </button>
    );
}
